import DueDateView from './due-date-view'

export default DueDateView
